import React from 'react';
import { Switch, Tooltip } from '@nextui-org/react';
import { useTranslation } from 'react-i18next';

export interface ExpandAllButtonProps {
    isExpanded: boolean;
    onToggle: () => void;
}

export const ExpandAllButton: React.FC<ExpandAllButtonProps> = ({
    isExpanded,
    onToggle
}) => {
    const { t } = useTranslation();
    const tooltipContent = isExpanded ? t('Collapse All') : t('Expand All');

    return (
        <Tooltip content={tooltipContent} placement="top" color="primary" showArrow>
            <span>
                <Switch
                    isSelected={isExpanded}
                    size="sm"
                    onChange={onToggle}
                    aria-label={tooltipContent}
                />
            </span>
        </Tooltip>
    );
};

